export default "__VITE_ASSET__Cu3wb7FG__"